<template>
  <div class="orderDetail">
    <div class="orderDetail_content">
      <div class="orderDetail_top">
        <van-icon name="arrow-left" @click="goBack" />
        <div class="title">订单详情</div>
        <van-icon v-show="showCloseCommunity" name="close" class="close_community" @click="closeCommunity" />

      </div>
      <div class="orderDetail_main">
        <div class="good_info">
          <div class="good_pic">
            <img :src="orderDetail.goodPic" alt="">
          </div>
          <div class="right">
            <div class="good_name">{{ orderDetail.goodName }}</div>
            <div class="good_num">x1</div>
          </div>
        </div>
        <div class="order_info">
          <div class="score flex">
            <span class="gray">消耗积分</span>
            <span>{{ orderDetail.price }}</span>
          </div>
          <div class="time flex">
            <span class="gray">兑换时间</span>
            <span>{{ orderDetail.created }}</span>
          </div>
          <div class="number flex">
            <span class="gray">订单编号</span>
            <div>
              <span>{{ orderId }}</span> |
              <span class="copy" v-clipboard:copy="orderId" v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError">复制</span>
            </div>
          </div>
        </div>
        <div class="order_user" v-if="orderInfo.roleId">
          <div class="sub_t">兑换角色</div>
          <div class="user_info">
            <div class="item">
              <span class="gray">角色ID</span>
              <span class="ml20">{{ orderInfo.roleId }}</span>
            </div>
            <div class="item">
              <span class="gray">角色昵称</span>
              <span class="ml20">{{ orderInfo.roleName }}</span>
            </div>
            <div class="item">
              <span class="gray">区服</span>
              <span class="ml20">{{ orderInfo.serverName }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <sideRight ref="sideRight" v-if="$padFalg != 'other'"></sideRight>

  </div>
</template>

<script>
import { Toast } from "vant";
import sideRight from "@/components/sideRight";
import get from "../../api/get";
export default {
  data() {
    return {
      applets: window.user.weixcode ? "xcx" : "",

      orderDetail: {
        goodName: "",
        price: "",
        created: "",
        orderId: "",
        goodPic: "",
      },
      orderInfo: {},
      orderId: "PD22103117481660008710003",
    };
  },
  components: {
    sideRight,
  },
  created() {
    this.orderId = this.$route.query.orderId;
    this.getOrderDetail();
  },
  computed: {
    showCloseCommunity() {
      return this.$store.state.system == 'android' && this.applets != 'xcx' && !this.$store.state.isXcx && this.$store.state.isInGame
    },
  },
  methods: {
    getOrderDetail() {
      get.getRecordDetail({ orderId: this.orderId }).then((res) => {
        if (res.data.code === 0) {
          let _data = res.data.data;
          this.orderDetail.goodName = _data.goodsName;
          this.orderDetail.price = _data.price;
          this.orderDetail.created = _data.createDate;
          this.orderDetail.goodPic = _data.picture;
          this.orderInfo = JSON.parse(_data.infos);
        }
      });
    },
    onCopy() {
      Toast("复制成功");
    },
    onCopyError() {
      Toast("复制z失败");
    },
    goBack() {
      this.$router.back();
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },
  },
};
</script>
<style lang="scss" scoped>
.ipad .orderDetail {
  width: 12.5rem;
  max-width: 15rem;
}

.orderDetail {
  height: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
  color: #2b2b2b;
  max-width: 8.5rem;
  display: flex;

  .orderDetail_top {
    position: fixed;
    z-index: 2;
    max-width: 8.5rem;
    width: 100%;
    height: 1.5rem;
    padding: 0.8rem 0.26rem 0;
    text-align: center;
    box-sizing: border-box;
    background-color: #f5f5f5;
    display: flex;

    .title {
      width: 100%;
      font-size: 0.34rem;
      color: #2b2b2b;
    }

    .close_community {
      position: absolute;
      font-size: 0.44rem;
      right: 0.2rem;
      cursor: pointer;
      color: #9b9da5;

    }

    .van-icon-arrow-left {
      position: absolute;
      left: 0.2rem;
      color: #9b9da5;
      font-size: 0.44rem;
      cursor: pointer;
    }
  }

  .orderDetail_content {
    max-width: 8.5rem;
    width: 100%;
  }

  .orderDetail_main {
    padding-top: 1.5rem;
    padding-bottom: 2rem;
    max-width: 8.5rem;
    width: 100%;

    .gray {
      color: #767676;
    }

    .copy {
      color: #2c89f1;
      cursor: pointer;
    }

    .good_info {
      display: flex;
      font-size: 0.26rem;
      padding: 0.3rem 0.26rem 0.2rem;
      border-bottom: 1px solid #eaeaea;
      background-color: #fff;

      .right {
        margin-left: 0.2rem;
        position: relative;
      }

      .good_pic {
        width: 1.48rem;
        height: 1.42rem;
        background-color: #f5f5f5;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .good_name {
        margin-top: 0.2rem;
      }

      .good_num {
        position: absolute;
        bottom: 0.1rem;
        color: #767676;
      }
    }

    .order_info {
      padding: 0.3rem 0.26rem 0;
      font-size: 0.24rem;
      background-color: #fff;

      .flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .score,
      .number,
      .time {
        padding-bottom: 0.26rem;
      }

      .sub_t {
        color: #767676;
      }
    }

    .order_user {
      background-color: #fff;

      .sub_t {
        // width: 100%;
        padding: 0 0.26rem;
        height: 0.86rem;
        line-height: 0.86rem;
        font-size: 0.24rem;
        background-color: #f5f5f5;
      }

      .user_info {
        padding: 0 0.26rem 0.3rem;
        overflow: hidden;
        font-size: 0.24rem;

        .item {
          float: left;
          width: 50%;
          margin-top: 0.2rem;
        }

        .ml20 {
          margin-left: 0.2rem;
        }
      }
    }
  }
}
</style>